export default __webpack_public_path__ + "static/media/cchat-logo-transparent.73fa7692.png";